import { t } from '@lingui/core/macro';
import type { ContactStatus } from '@duke-hq/svc-api-db/client';

export const contactStatusMeta: Record<ContactStatus, { label: () => string }> = {
  INITIAL_STUDENT_CONTACT: { label: () => t`Initial student contact` },
  PENDING_CONTACT: { label: () => t`Pending contact` },
  FIRST_CONTACT_MADE: { label: () => t`First contact made` },
  REVIEWING_CANDIDATE: { label: () => t`Reviewing candidate` },
  DECLINED: { label: () => t`Declined` },
};

export const contactStatusOrder: ContactStatus[] = [
  'INITIAL_STUDENT_CONTACT',
  'PENDING_CONTACT',
  'FIRST_CONTACT_MADE',
  'REVIEWING_CANDIDATE',
  'DECLINED',
];

export function isContactStatus(value: string): value is ContactStatus {
  return Object.hasOwn(contactStatusMeta, value);
}
